import { render } from "./SelectPrincipal.vue?vue&type=template&id=229a6181&scoped=true"
import script from "./SelectPrincipal.vue?vue&type=script&lang=js"
export * from "./SelectPrincipal.vue?vue&type=script&lang=js"

import "./SelectPrincipal.vue?vue&type=style&index=0&id=229a6181&lang=scss&scoped=true"
import "./SelectPrincipal.vue?vue&type=style&index=1&id=229a6181&lang=scss"

import exportComponent from "../../../../../github.com:rancher/dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-229a6181"]])

export default __exports__